import { useCallback, useEffect, useRef, useState } from "react"
import { PublicService } from "services/api-service"
import { ProfileCompanyType } from "services/api-service/types"
import { SentryService } from "services/SentryService"

export const useSearchCompanyByNumber = (
  countryCode: string,
  value: string,
  onSuccess: (e: Partial<ProfileCompanyType>) => void,
) => {
  const timeoutId = useRef<NodeJS.Timeout | null>(null)
  const firstTime = useRef(true)

  const [loading, setLoading] = useState(false)
  const [isValid, setIsValid] = useState(false)

  const searchCompanyByNip = useCallback(
    async (number: string) => {
      try {
        setLoading(true)
        setIsValid(false)
        const res = await PublicService.getCompanyFromGUS(number)
        onSuccess(res)
        setIsValid(true)
      } catch (e) {
        // SentryService.error("[ERROR PublicService.getCompanyFromGUS]:", e)
        setIsValid(false)
      } finally {
        setLoading(false)
      }
    },
    [onSuccess],
  )

  const searchCompanyByVIES = useCallback(
    async (number: string) => {
      try {
        setLoading(true)
        setIsValid(false)
        const res = await PublicService.getCompanyFromVIES(`${countryCode}${number}`)
        onSuccess({
          name: res.traderName,
          countryCode: countryCode,
        })
        setIsValid(true)
      } catch (e) {
        SentryService.error("[ERROR PublicService.getCompanyFromVIES]:", e)
        setIsValid(false)
      } finally {
        setLoading(false)
      }
    },
    [countryCode, onSuccess],
  )

  useEffect(() => {
    if (firstTime.current) {
      firstTime.current = false
      return
    }

    if (timeoutId.current) {
      clearTimeout(timeoutId.current)
    }

    timeoutId.current = setTimeout(() => {
      if (value && value.length > 1) {
        if (countryCode === "PL") {
          if (value.length === 10) {
            searchCompanyByNip(value)
          } else {
            setIsValid(false)
          }
        } else {
          searchCompanyByVIES(value)
        }
      } else {
        setIsValid(false)
      }
    }, 1000)
  }, [countryCode, searchCompanyByNip, searchCompanyByVIES, value])

  return [loading, isValid]
}
